import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr'; // Adjust path as needed

@Component({
  selector: 'btn-cell-renderer-pm-history',
  template: `
    <style>
      .view-btn {
        color: white;
        background: #3aafe4;
        margin-right: 5px;
      }
      i {
        color: white;
      }
      .btn:disabled {
        opacity: 0.5;
      }
      .btn {
        border: none;
        border-radius: 20px;
        cursor: pointer;
      }
      .config-btns {
        display: flex;
      }
      .parameter-btn {
        color: white;
        background: #4caf50;
        margin-right: 5px;
      }
    </style>
    <div class="config-btns">
      <button
        class="view-btn btn"
        [title]="t('ViewTechnicianTasksHistory', 'View Technician Tasks History')"
        mat-icon-button
        (click)="onClickView($event)"
      >
        <i
          class="fa fa-eye"
          aria-hidden="true"
          style="padding:9px;font-size:18px;"
        ></i>
      </button>

      <button
        class="parameter-btn btn"
        mat-icon-button
        [title]="t('ViewParameterHistory', 'View Parameter History')"
        (click)="onClickParameterHistory($event)"
      >
        <i
          class="fa fa-cogs"
          aria-hidden="true"
          style="padding:9px;font-size:18px;"
        ></i>
      </button>
    </div>
  `,
})
export class ActionViewPMHistoryBtnRenderer
  implements ICellRendererAngularComp, OnDestroy
{
  params: any;

  constructor(private dialog: MatDialog, private toaster: ToastrService, public translate: TranslateService) {}

  /** "PM.<key>" from the JSON files -> flat key -> English fallback. */
  public t(key: string, fallback: string): string {
    for (const candidate of ['PM.' + key, key]) {
      const value = this.translate.instant(candidate);
      if (typeof value === 'string' && value !== candidate) {
        return value;
      }
      if (value && typeof value === 'object' && typeof value.title === 'string') {
        return value.title;
      }
    }
    return fallback;
  }


  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  onClickView($event: any): void {
    if (this.params.onClickView instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickView(params);
    }
  }

  onClickParameterHistory($event: any): void {
    if (this.params.onClickParameterHistory instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickParameterHistory(params);
    }
  }

  ngOnDestroy(): void {
    // No need to remove button click handlers
  }
}
